import { isContinuous, isDiscrete } from "@visactor/vscale";

import { getDatumByValue } from "./common";

import { getAxisLabelOffset } from "../../axis/util";

import { isValid } from "@visactor/vutils";

import { getFormatFunction } from "../../util";

export const layoutByValue = (tag = 3, series, layoutStartPoint, currValueX, currValueY, xHair, yHair, enableRemain = !1, cacheXCrossHairInfo, cacheYCrossHairInfo) => {
    const layoutX = 1 & tag, layoutY = 2 & tag;
    layoutStartPoint || (layoutStartPoint = {
        x: 0,
        y: 0
    });
    let xAxis = null, yAxis = null, x = 0, y = 0;
    if (currValueX.size) {
        const item = Array.from(currValueX.values())[0];
        x = item.axis.getScale().scale(item.value) + item.axis.getLayoutStartPoint().x - layoutStartPoint.x, 
        xAxis = item.axis;
    }
    if (currValueY.size) {
        const item = Array.from(currValueY.values())[0];
        y = item.axis.getScale().scale(item.value) + item.axis.getLayoutStartPoint().y - layoutStartPoint.y, 
        yAxis = item.axis;
    }
    const xVisible = !!currValueX.size && Number.isFinite(x), yVisible = !!currValueY.size && Number.isFinite(y), xUseCache = enableRemain && !xVisible && isValid(cacheXCrossHairInfo), yUseCache = enableRemain && !yVisible && isValid(cacheYCrossHairInfo);
    let xCrossHairInfo, yCrossHairInfo, bandWidth;
    layoutX && (xCrossHairInfo = xUseCache ? cacheXCrossHairInfo : {
        height: 0,
        leftPos: 0,
        rightPos: 0,
        topPos: 0,
        x: 0,
        bottom: {
            visible: !1,
            text: "",
            dx: 0,
            dy: 0
        },
        top: {
            visible: !1,
            text: "",
            dx: 0,
            dy: 0
        },
        visible: xVisible,
        axis: xAxis
    }), layoutY && (yCrossHairInfo = yUseCache ? cacheYCrossHairInfo : {
        width: 0,
        leftPos: 0,
        topPos: 0,
        bottomPos: 0,
        y: 0,
        left: {
            visible: !1,
            text: "",
            dx: 0,
            dy: 0
        },
        right: {
            visible: !1,
            text: "",
            dx: 0,
            dy: 0
        },
        visible: yVisible,
        axis: yAxis
    });
    let bandHeight, offsetWidth = 0, offsetHeight = 0;
    if (xHair && currValueX.forEach((({axis: axis, value: value}) => {
        var _a;
        value = null != value ? value : "";
        let niceLabelFormatter = null;
        const xScale = axis.getScale();
        if (isDiscrete(xScale.type)) bandWidth = xScale.bandwidth(), 0 === bandWidth && xScale.step && (offsetWidth = xScale.step()); else if (isContinuous(xScale.type)) {
            const fieldX = series.fieldX[0], fieldX2 = series.fieldX2, datum = getDatumByValue(series.getViewData().latestData, +value, fieldX, fieldX2);
            if (datum) {
                const startX = series.dataToPositionX(datum);
                fieldX2 ? (bandWidth = Math.abs(startX - series.dataToPositionX1(datum)), value = `${datum[fieldX]} ~ ${datum[fieldX2]}`) : bandWidth = 1, 
                x = startX;
            }
            niceLabelFormatter = axis.niceLabelFormatter;
        }
        if (xCrossHairInfo && (null === (_a = xHair.label) || void 0 === _a ? void 0 : _a.visible) && !xUseCache) {
            const labelOffset = getAxisLabelOffset(axis.getSpec());
            "bottom" === axis.getOrient() ? (xCrossHairInfo.bottom.visible = !0, xCrossHairInfo.bottom.defaultFormatter = niceLabelFormatter, 
            xCrossHairInfo.bottom.text = value, xCrossHairInfo.bottom.dx = 0, xCrossHairInfo.bottom.dy = labelOffset) : "top" === axis.getOrient() && (xCrossHairInfo.top.visible = !0, 
            xCrossHairInfo.top.defaultFormatter = niceLabelFormatter, xCrossHairInfo.top.text = value, 
            xCrossHairInfo.top.dx = 0, xCrossHairInfo.top.dy = -labelOffset);
        }
    })), yHair && currValueY.forEach((({axis: axis, value: value}) => {
        var _a;
        value = null != value ? value : "";
        let niceLabelFormatter = null;
        const yScale = axis.getScale();
        if (isDiscrete(yScale.type)) bandHeight = yScale.bandwidth(), 0 === bandHeight && yScale.step && (offsetHeight = yScale.step()); else if (isContinuous(yScale.type)) {
            const fieldY = series.fieldY[0], fieldY2 = series.fieldY2, datum = getDatumByValue(series.getViewData().latestData, +value, fieldY, fieldY2);
            if (datum) {
                const startY = series.dataToPositionY(datum);
                fieldY2 ? (bandHeight = Math.abs(startY - series.dataToPositionY1(datum)), value = `${datum[fieldY]} ~ ${datum[fieldY2]}`) : bandHeight = 1, 
                y = startY;
            }
            niceLabelFormatter = axis.niceLabelFormatter;
        }
        if (yCrossHairInfo && (null === (_a = yHair.label) || void 0 === _a ? void 0 : _a.visible) && !yUseCache) {
            const labelOffset = getAxisLabelOffset(axis.getSpec());
            "left" === axis.getOrient() ? (yCrossHairInfo.left.visible = !0, yCrossHairInfo.left.defaultFormatter = niceLabelFormatter, 
            yCrossHairInfo.left.text = value, yCrossHairInfo.left.dx = -labelOffset, yCrossHairInfo.left.dy = 0) : "right" === axis.getOrient() && (yCrossHairInfo.right.visible = !0, 
            yCrossHairInfo.right.defaultFormatter = niceLabelFormatter, yCrossHairInfo.right.text = value, 
            yCrossHairInfo.right.dx = labelOffset, yCrossHairInfo.right.dy = 0);
        }
    })), xCrossHairInfo && !xUseCache) {
        const xRegion = {
            x1: 1 / 0,
            y1: 1 / 0,
            x2: -1 / 0,
            y2: -1 / 0
        };
        if (setRegionArea(xRegion, currValueX), xCrossHairInfo.leftPos = xRegion.x1, xCrossHairInfo.rightPos = xRegion.x2, 
        xCrossHairInfo.topPos = xRegion.y1, xCrossHairInfo.height = xRegion.y2 - xRegion.y1, 
        xCrossHairInfo.x = x + layoutStartPoint.x, xHair && xHair.label) {
            const {top: top, bottom: bottom} = xCrossHairInfo;
            top.visible && setFormattedCrosshairLabel(top, "top", xHair.label), bottom.visible && setFormattedCrosshairLabel(bottom, "bottom", xHair.label);
        }
    }
    if (yCrossHairInfo && !yUseCache) {
        const yRegion = {
            x1: 1 / 0,
            y1: 1 / 0,
            x2: -1 / 0,
            y2: -1 / 0
        };
        if (setRegionArea(yRegion, currValueY), yCrossHairInfo.leftPos = yRegion.x1, yCrossHairInfo.topPos = yRegion.y1, 
        yCrossHairInfo.bottomPos = yRegion.y2, yCrossHairInfo.width = yRegion.x2 - yRegion.x1, 
        yCrossHairInfo.y = y + layoutStartPoint.y, yHair && yHair.label) {
            const {left: left, right: right} = yCrossHairInfo;
            left.visible && setFormattedCrosshairLabel(left, "left", yHair.label), right.visible && setFormattedCrosshairLabel(right, "right", yHair.label);
        }
    }
    return {
        x: layoutX && xCrossHairInfo ? xCrossHairInfo : void 0,
        y: layoutY && yCrossHairInfo ? yCrossHairInfo : void 0,
        offsetWidth: offsetWidth,
        offsetHeight: offsetHeight,
        bandWidth: null != bandWidth ? bandWidth : 0,
        bandHeight: null != bandHeight ? bandHeight : 0
    };
};

const setFormattedCrosshairLabel = (labelInfo, position, labelSpec) => {
    const {formatMethod: formatMethod, formatter: formatter} = labelSpec, {formatFunc: formatFunc, args: args} = getFormatFunction(formatMethod, formatter, labelInfo.text, {
        label: labelInfo.text,
        position: position
    });
    formatFunc ? labelInfo.text = formatFunc(...args) : labelInfo.defaultFormatter && (labelInfo.text = labelInfo.defaultFormatter(labelInfo.text));
}, setRegionArea = (outRegion, currentValue) => {
    currentValue.forEach((({axis: axis}) => {
        axis.getRegions().forEach((r => {
            outRegion.x1 = Math.min(outRegion.x1, r.getLayoutStartPoint().x), outRegion.y1 = Math.min(outRegion.y1, r.getLayoutStartPoint().y), 
            outRegion.x2 = Math.max(outRegion.x2, r.getLayoutStartPoint().x + r.getLayoutRect().width), 
            outRegion.y2 = Math.max(outRegion.y2, r.getLayoutStartPoint().y + r.getLayoutRect().height);
        }));
    }));
};

export const layoutVerticalCrosshair = (xHair, crosshairInfo, bandWidth, offsetWidth) => {
    const {x: x, topPos: topPos, height: height} = crosshairInfo, type = xHair.type;
    let positionAttribute;
    if ("line" === type) positionAttribute = {
        visible: !0,
        start: {
            x: x + bandWidth / 2,
            y: topPos
        },
        end: {
            x: x + bandWidth / 2,
            y: topPos + height
        }
    }; else if ("rect" === type) {
        const extend = getRectSize(xHair, bandWidth, crosshairInfo.axis), {leftPos: leftPos, rightPos: rightPos} = crosshairInfo;
        positionAttribute = {
            visible: !0,
            start: {
                x: Math.max(x - extend / 2 - offsetWidth / 2, leftPos),
                y: topPos
            },
            end: {
                x: Math.min(x + bandWidth + extend / 2 + offsetWidth / 2, rightPos),
                y: topPos + height
            }
        };
    }
    return positionAttribute;
};

export const layoutHorizontalCrosshair = (yHair, crosshairInfo, bandHeight, offsetHeight) => {
    const {leftPos: leftPos, width: width, y: y} = crosshairInfo, type = yHair.type;
    let positionAttribute;
    if ("line" === type) positionAttribute = {
        visible: !0,
        start: {
            x: leftPos,
            y: y + bandHeight / 2
        },
        end: {
            x: leftPos + width,
            y: y + bandHeight / 2
        }
    }; else if ("rect" === type) {
        const extend = getRectSize(yHair, bandHeight, crosshairInfo.axis), {topPos: topPos, bottomPos: bottomPos} = crosshairInfo;
        positionAttribute = {
            visible: !0,
            start: {
                x: leftPos,
                y: Math.max(y - extend / 2 - offsetHeight / 2, topPos)
            },
            end: {
                x: leftPos + width,
                y: Math.min(y + bandHeight + extend / 2 + offsetHeight / 2, bottomPos)
            }
        };
    }
    return positionAttribute;
};

const getRectSize = (hair, bandSize, axis) => {
    var _a, _b, _c;
    let extend = 0;
    if (null === (_a = hair.style) || void 0 === _a ? void 0 : _a.sizePercent) extend = (hair.style.sizePercent - 1) * bandSize; else if ("number" == typeof (null === (_b = hair.style) || void 0 === _b ? void 0 : _b.size)) extend = hair.style.size - bandSize; else if ("function" == typeof (null === (_c = hair.style) || void 0 === _c ? void 0 : _c.size)) {
        const axisRect = axis.getLayoutRect();
        extend = hair.style.size(axisRect, axis) - bandSize;
    }
    return extend;
};
//# sourceMappingURL=cartesian.js.map
